import type { PartialMessage } from '@bufbuild/protobuf'
import { Media } from '@fingertip/creator-proto/gen/fingertip/common/type/v1/media_pb'

import { BlockCarousel } from '@/components/shared/block-carousel'

import { MediaImage } from '../blocks/shared/media-image'

type Props = {
  mediaAssets: { productVariantId?: string; media: PartialMessage<Media> }[]
  height: number
  width: number
  startIndex: number
}

export const ProductMediaCarousel = ({
  mediaAssets,
  height,
  width,
  startIndex,
}: Props) => {
  return (
    <BlockCarousel
      count={mediaAssets.length}
      options={{
        startIndex,
      }}
    >
      {mediaAssets.map((mediaAsset, index) => {
        return (
          <div
            key={index}
            className="relative size-full shrink-0 overflow-hidden rounded-page-widget-inner"
            style={{ height }}
          >
            <MediaImage
              width={width}
              height={height}
              media={mediaAsset.media}
              title={mediaAsset?.media?.altText}
              className="mx-auto"
            />
          </div>
        )
      })}
    </BlockCarousel>
  )
}
